const { actions, sendParent } = require("xstate");
const { assign } = actions;

const saveDescription = assign({
  correctiveAction: (context, event) => {
    return {
      ...context.correctiveAction,
      description: event.data,
    };
  },
  changes: (context, event) => {
    return new Set([...context.changes, "description"]);
  },
});

const saveStatus = assign({
  correctiveAction: (context, event) => {
    return {
      ...context.correctiveAction,
      status: event.data,
    };
  },
  changes: (context, event) => {
    return new Set([...context.changes, "status"]);
  },
});

const sendDeleteEventToParent = sendParent((context) => ({
  type: "CORRECTIVE_ACTION.DELETE",
  id: context.correctiveAction.id,
}));

const sendUpdateEventToParent = sendParent((context) => ({
  type: "CORRECTIVE_ACTION.UPDATE",
  correctiveAction: context.correctiveAction,
}));

const saveHandlerType = assign({
  correctiveAction: (context, event) => {
    return {
      ...context.correctiveAction,
      handler_type: event.data,
    };
  },
  changes: (context, event) => {
    return new Set([...context.changes, "handler_type"]);
  },
});

const saveExpirationDate = assign({
  correctiveAction: (context, event) => {
    return {
      ...context.correctiveAction,
      expired_at: event.data,
    };
  },
  changes: (context, event) => {
    return new Set([...context.changes, "expired_at"]);
  },
});

const saveDeferralReason = assign({
  correctiveAction: (context, event) => {
    console.log(event);
    return {
      ...context.correctiveAction,
      deferral_reason: event?.data,
    };
  },
  changes: (context, event) => {
    return new Set([...context.changes, "deferral_reason"]);
  },
});

const emptyChanges = assign({
  changes: (context, event) => {
    return new Set();
  },
});

const flagChanges = require("../../commons/actions").flagChanges;
const unflagChanges = require("../../commons/actions").unflagChanges;
const saveToken = require("../../commons/actions").saveToken;
const saveError = require("../../commons/actions").saveError;
const flagDeferralReasonAsMandatory =
  require("../../commons/actions").flagDeferralReasonAsMandatory;
const unflagDeferralReasonAsMandatory =
  require("../../commons/actions").unflagDeferralReasonAsMandatory;

export {
  saveDescription,
  saveStatus,
  sendDeleteEventToParent,
  sendUpdateEventToParent,
  flagChanges,
  unflagChanges,
  saveToken,
  saveHandlerType,
  saveExpirationDate,
  saveError,
  saveDeferralReason,
  flagDeferralReasonAsMandatory,
  emptyChanges,
  unflagDeferralReasonAsMandatory,
};
